import { render, staticRenderFns } from "./TaskCards.vue?vue&type=template&id=61baa8de&scoped=true"
import script from "./TaskCards.vue?vue&type=script&lang=js"
export * from "./TaskCards.vue?vue&type=script&lang=js"
import style0 from "./TaskCards.vue?vue&type=style&index=0&id=61baa8de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61baa8de",
  null
  
)

export default component.exports